import type { FrigateParams } from './procedural/FrigateBuilder';

export type ShipColor = 'blue' | 'green' | 'orange' | 'purple' | 'red';

export const SHIP_COLORS: Record<ShipColor, string> = {
  blue: '#2f6fe8', green: '#2fa85a', orange: '#e0782a', purple: '#7e4fd6', red: '#c9302c',
};

export type ShipSpec = {
  id: string;
  name: string;
  role: string;
  colors: ShipColor[];
  length: number; // metres
  /** 0..1 stats shown in the menu; applied as multipliers in flight */
  speed: number;
  handling: number;
  shield: number;
  engineColor: string;
  frigate: Omit<FrigateParams, 'length' | 'registry'>;
};

const ALL: ShipColor[] = ['blue', 'green', 'orange', 'purple', 'red'];

// Four procedural capital-ship classes (ids kept stable for the network protocol).
// Balanced so no ship is strictly best (sum of stats ≈ 2.0).
export const SHIPS: ShipSpec[] = [
  {
    id: 'challenger', name: 'Challenger', role: 'Strike frigate', colors: ALL, length: 140,
    speed: 0.9, handling: 0.75, shield: 0.35, engineColor: '#6fd0ff',
    frigate: { seed: 11, width: 0.17, height: 0.095, prow: 0.42, sponsons: false, wingSpan: 0.2, wingSweep: 30, dorsalFin: true, engines: { cols: 3, rows: 1 }, turrets: 1, dish: false },
  },
  {
    id: 'bob', name: 'Odyssey', role: 'Deep-space explorer', colors: ALL, length: 160,
    speed: 0.65, handling: 0.65, shield: 0.7, engineColor: '#ffb36b',
    frigate: { seed: 23, width: 0.2, height: 0.12, prow: 0.34, sponsons: true, wingSpan: 0, wingSweep: 0, dorsalFin: false, engines: { cols: 2, rows: 2 }, turrets: 0, dish: true },
  },
  {
    id: 'dispatcher', name: 'Dispatcher', role: 'Fast courier', colors: ALL, length: 120,
    speed: 0.75, handling: 0.95, shield: 0.3, engineColor: '#b58bff',
    frigate: { seed: 37, width: 0.14, height: 0.085, prow: 0.48, sponsons: false, wingSpan: 0.28, wingSweep: 45, dorsalFin: true, engines: { cols: 2, rows: 1 }, turrets: 0, dish: false },
  },
  {
    id: 'executioner', name: 'Executioner', role: 'Heavy cruiser', colors: ALL, length: 200,
    speed: 0.55, handling: 0.45, shield: 1.0, engineColor: '#ff6a5a',
    frigate: { seed: 51, width: 0.22, height: 0.11, prow: 0.3, sponsons: true, wingSpan: 0.12, wingSweep: 20, dorsalFin: false, engines: { cols: 3, rows: 2 }, turrets: 3, dish: false },
  },
];

export const SHIP_BY_ID = new Map(SHIPS.map((s) => [s.id, s]));
